var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 7C19.333 7.184 19.1837 7.33333 18.9997 7.33333H17.9997C17.9997 7.34333 17.9997 7.35333 17.9983 7.364L17.085 17.2753C16.9417 18.8287 15.657 20 14.0977 20H9.91633C8.35833 20 7.07433 18.8307 6.92966 17.28L6.00166 7.36467C6.00099 7.354 6.00033 7.344 6.00033 7.33333H5.00033C4.81633 7.33333 4.66699 7.184 4.66699 7C4.66699 6.816 4.81633 6.66667 5.00033 6.66667H8.35233C8.51899 5.16867 9.79233 4 11.3337 4H12.667C14.2083 4 15.4823 5.16867 15.6483 6.66667H19.0003C19.1843 6.66667 19.333 6.816 19.333 7ZM9.02366 6.66667H14.9757C14.8137 5.53733 13.8397 4.66667 12.6663 4.66667H11.333C10.1597 4.66667 9.18566 5.53733 9.02366 6.66667ZM17.3317 7.33333H6.66766L7.59233 17.2173C7.70433 18.424 8.70366 19.3333 9.91499 19.3333H14.0963C15.3097 19.3333 16.3083 18.4227 16.4197 17.214L17.3303 7.33333H17.3317Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55811 9.26562V17.0058M11.9474 9.26562V17.0058M14.373 9.26562V17.0058",
    stroke: "currentColor",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.45edda371472eccc1daad495fe91123d.svg";
export { ForwardRef as ReactComponent };